import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Login } from './pages/Login/Login'
import { Login2 } from './pages/Login/Login2'
import { Home } from './pages/Home/Home'
import { ForgotPassword } from './pages/ForgotPassword/ForgotPassword'

//protected routes based on roles
import {
  ProtectedRoutes,
  ProtectedRoutesEmployee,
  ProtectedRoutesHREmployee,
  ProtectedRoutesHRInterviewer,
  ProtectedRoutesHR,
  ProtectedRoutesInterviewer,
} from './components/ProtectedRoutes'

//HRMS components
import { UserHome } from './HRMS/pages/UserHome/UserHome'
import { Registration } from './HRMS/pages/Registration/Registration'
import { ApplicantProfile } from './HRMS/pages/ApplicantProfile/ApplicantProfile'
import { RecoverApplications } from './HRMS/pages/RecoverApplications/RecoverApplications'
import { FindApplication } from './HRMS/pages/FindApplication/FindApplication'
import { InterviewerDashboard } from './HRMS/pages/InterviewerDashboard/InterviewerDashboard'
import { InterviewHistory } from './HRMS/pages/InterviewHistory/InterviewHistory'
import { CandidateDetails } from './HRMS/pages/CandidateDetails/CandidateDetails'
import { Profile } from './HRMS/pages/Profile/Profile'
import { UserList } from './HRMS/pages/UserList/UserList'
import { AddCandidate } from './HRMS/pages/AddCandidate/AddCandidate'
import { EditUser } from './HRMS/pages/EditUser/EditUser'

//Reimbursement components
// import { HRHome } from './Reimbursement/pages/HRHome/HRHome'
import { EditRequest } from './Reimbursement/pages/EditRequest/EditRequest'
import { Report } from './Reimbursement/pages/Report/Report'
import { AdminDashboard } from './Reimbursement/pages/AdminDashboard/AdminDashboard'
import { BillHistory } from './Reimbursement/pages/BillHistory/BillHistory'
import { AdminRequest } from './Reimbursement/pages/AdminRequest/AdminRequest'

//ExamSimulator components
import { Dashboard } from './Exam-Simulator/pages/AdminDashboard/Dashboard'
import { AddExam } from './Exam-Simulator/pages/Exam Mgmt/AddExam/AddExam'
import { ViewExams } from './Exam-Simulator/pages/Exam Mgmt/ViewExam/ViewExams'
import { ViewQuestion } from './Exam-Simulator/pages/Question Mgmt/ViewQuestion/ViewQuestion'
import { AddQuestion } from './Exam-Simulator/pages/Question Mgmt/AddQuestion/AddQuestion'
import { ExamStatus } from './Exam-Simulator/pages/ExamStatus/ExamStatus'
import { AddStudents } from './Exam-Simulator/pages/AddStudent/AddStudents'
import { ViewSubject } from './Exam-Simulator/pages/Subject Mgmt/View Subject/ViewSubject'
import { Referral } from './HRMS/pages/Referral/Referral'
import { ReferralProfile } from './HRMS/pages/ReferralProfile/ReferralProfile'
import { Position } from './HRMS/pages/Position/Position'
import { ViewStudent } from './Exam-Simulator/pages/AddStudent/ViewStudent'
import { EditStudent } from './Exam-Simulator/pages/AddStudent/EditStudent'
import { ExamHistory } from './Exam-Simulator/pages/AdminDashboard/ExamHistory'

//employee
import { AddReferral } from './Employee/Pages/Referral/AddReferral/AddReferral'
import { ViewReferral } from './Employee/Pages/Referral/ViewReferral/ViewReferral'
import { ViewReimburse } from './Employee/Pages/Reimbursement/ViewReimburse/ViewReimburse'
import { AddReimburse } from './Employee/Pages/Reimbursement/AddReimburse/AddReimburse'
import { Rejected } from './Reimbursement/pages/RejectedRequests/Rejected'
import { EditReimburse } from './Employee/Pages/Reimbursement/EditReimburse/EditReimburse'
import { AccountsDashboard } from './Reimbursement/pages/AccountsDashboard/AccountsDashboard'
import { useLocation } from 'react-router-dom'

function App() {
  const location = useLocation()
  if (location.pathname === '/') {
    window.history.pushState(null, document.URL, window.location.href)
    window.addEventListener('popstate', function (event) {
      window.history.pushState(null, document.URL, window.location.href)
    })
  } else if (location.pathname === '/ADMS') {
    window.history.pushState(null, document.URL, window.location.href)
    window.addEventListener('popstate', function (event) {
      window.history.pushState(null, document.URL, window.location.href)
    })
  }
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/ADMS" element={<Login2 />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />

        {/* Routes procted on the bases of role : HR / Admin */}
        <Route path="/" element={<ProtectedRoutesHR />}>
          {/* HRMS */}
          <Route path="/home" element={<UserHome />} />
          <Route path="/applicantProfile/:id" element={<ApplicantProfile />} />
          <Route
            path="/recoverapplications"
            element={<RecoverApplications />}
          />

          <Route path="/findApplications" element={<FindApplication />} />
          <Route path="/userList" element={<UserList />} />
          <Route path="/register" element={<Registration />} />
          <Route path="/addCandidate" element={<AddCandidate />} />
          <Route path="/editUser/:id" element={<EditUser />} />
          <Route path="/referral" element={<Referral />} />
          <Route path="/referralProfile/:id" element={<ReferralProfile />} />
          <Route path="/position-mgmt" element={<Position />} />
          {/* Reimbursement */}
          <Route path="/dashboard" element={<Report />} />
          <Route path="/editRequest/:id" element={<EditRequest />} />
          {/* <Route path="/report" element={<Report />} /> */}
          <Route path="/admindashboard" element={<AdminDashboard />} />
          <Route path="/billhistory" element={<BillHistory />} />
          <Route path="/adminrequest/:id" element={<AdminRequest />} />
          <Route path="/rejectedRequests" element={<Rejected />} />
          <Route path="/accounts-dashboard" element={<AccountsDashboard />} />
          {/* ExamSimulator */}
          <Route path="/examdashboard" element={<Dashboard />} />
          <Route path="/addexam" element={<AddExam />} />
          <Route path="/viewexams" element={<ViewExams />} />
          <Route path="/viewquestion" element={<ViewQuestion />} />
          <Route path="/addquestion" element={<AddQuestion />} />
          <Route path="/examstatus" element={<ExamStatus />} />
          <Route path="/addstudent" element={<AddStudents />} />
          <Route path="/viewsubjects" element={<ViewSubject />} />
          <Route path="/viewstudents" element={<ViewStudent />} />
          <Route path="/studentdetails/:id" element={<EditStudent />} />
          <Route path="/exam-history/:id/:examid" element={<ExamHistory />} />
        </Route>

        {/* Routes procted on the bases of role : Interviewer*/}
        <Route path="/" element={<ProtectedRoutesInterviewer />}>
          {/* HRMS */}
          <Route
            path="/interviewerDashboard"
            element={<InterviewerDashboard />}
          />
        </Route>

        {/* Routes procted on the bases of role : HR/Admin/Interviewer/Employee (general access) */}
        <Route path="/" element={<ProtectedRoutes />}>
          <Route path="/portal" element={<Home />} />
        </Route>

        {/* Routes procted on the bases of role : HR/Admin/Interviewer (general access) */}
        <Route path="/" element={<ProtectedRoutesHRInterviewer />}>
          {/* HRMS */}
          <Route path="/profile" element={<Profile />} />
          <Route path="/viewDetails/:id" element={<CandidateDetails />} />
          <Route path="/interviewHistory" element={<InterviewHistory />} />
        </Route>

        {/* Routes procted on the bases of role : HR/Admin/Employee (general access) */}
        <Route path="/" element={<ProtectedRoutesHREmployee />}>
          {/* HRMS */}
          <Route path="/add-referral" element={<AddReferral />} />
          <Route path="/view-referral" element={<ViewReferral />} />
        </Route>

        {/* Routes procted on the bases of role : Employee */}
        <Route path="/" element={<ProtectedRoutesEmployee />}>
          <Route path="/add-reimburse" element={<AddReimburse />} />
          <Route path="/view-reimburse" element={<ViewReimburse />} />
          <Route path="/edit-reimburse/:id" element={<EditReimburse />} />
        </Route>
      </Routes>
    </div>
  )
}

export default App
